var _defs, _path, _rect, _rect2, _rect3, _path2, _path3, _path4, _path5, _path6, _path7, _rect4, _rect5, _path8, _path9, _path0, _path1, _path10, _rect6, _rect7, _path11, _path12, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _circle, _circle2, _path13, _polyline, _path14, _path15, _polygon, _rect13, _rect14, _path16, _g, _path17, _path18, _path19, _rect15, _rect16, _circle3, _path20, _rect17, _path21, _path22, _polygon2, _path23, _rect18, _rect19, _rect20, _path24, _path25, _rect21, _path26, _rect22, _path27, _path28, _rect23, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _rect24, _rect25, _path40, _path41, _rect26, _path42, _path43, _path44, _path45, _path46, _rect27, _rect28, _rect29, _path47, _path48, _path49, _circle4, _circle5, _polygon3, _path50, _ellipse, _path51, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _path52, _circle6, _path53, _path54, _path55, _rect36, _rect37, _path56, _circle7, _rect38, _path57, _circle8, _rect39, _rect40, _rect41;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgContestIllustration = (_ref, ref) => {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1202.82 1156.93",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-contest1{fill:none;}.cls-contest2{fill:#c8633a;}.cls-contest3{fill:#68260f;}.cls-contest4{fill:#30252a;}.cls-contest5{fill:#fcb4d2;}.cls-contest6{fill:#ffbe21;}.cls-contest7{fill:#22c67b;}.cls-contest8{fill:#fff;}.cls-contest9{fill:#fa3b3c;}.cls-contest10{fill:#f2b197;}.cls-contest11{fill:#4756df;}.cls-contest12{clip-path:url(#clip-path);}.cls-contest13{fill:#fce268;}.cls-contest14{fill:#ffc8ae;}.cls-contest15{fill:#d87a55;}.cls-contest16{fill:#e68f5b;}.cls-contest17{fill:#84401e;}.cls-contest18{fill:#ffb7d5;}.cls-contest19{fill:#7784f5;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-contest1",
    d: "M1198.75,698.75c-11-20-32.3-24-32.3-24l-62-12.87-67.64,1.57L1008,665.78s-39.24,2.43-50.22,13.81S926.46,717,926.46,717L955.13,736,926.7,850.48h263.62c2.45-11.71,4.59-18.8,3.89-28.42-.73-10.07-5.19-19.55-6.39-29.58-1.6-13.47,2.74-26.85,7-39.71C1194.84,752.77,1209.79,718.73,1198.75,698.75Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest2",
    d: "M279.19,855.89,305,760.26s-41.88-8.55-39.85-49.14c1.67-33.32,37.54-18.82,37.54-18.82s-12-47.88,18.13-77.79,80.07-12.27,96.34,21.35,30.71,76.69,35.08,91.74,7.16,44.83-14.08,65-51.49,22.13-79.85,16.16l3.86,47.17Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest3",
    x: 289.47,
    y: 703.32,
    width: 5,
    height: 24.71,
    transform: "translate(-480.97 718.09) rotate(-67.99)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest4",
    x: 357.26,
    y: 697.69,
    width: 21.24,
    height: 5,
    transform: "translate(-246 201.43) rotate(-23.19)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest4",
    x: 414.63,
    y: 683.99,
    width: 15.95,
    height: 5,
    transform: "translate(-130.17 99.71) rotate(-11.67)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest3",
    d: "M413.07,740.43,410.78,736c1.62-.83,2.55-1.8,2.77-2.88.33-1.66-.94-3.62-1.46-4.24l-8.23-10.4,3.92-3.1,8.14,10.29c.5.59,3.35,4.2,2.54,8.38C418.1,735.87,416.88,738.46,413.07,740.43Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest3",
    d: "M398.77,754.91a16.52,16.52,0,0,1-4.48-.64c-7.28-2.08-9.73-9.73-9.83-10.06l4.77-1.48s1.78,5.4,6.43,6.73a10.26,10.26,0,0,0,10.41-2.71l3.8,3.25A15.28,15.28,0,0,1,398.77,754.91Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest3",
    d: "M357.69,811.15c-.56-.13-13.89-3.31-23-9.76l2.89-4.08c8.3,5.88,21.12,9,21.25,9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest4",
    d: "M302.65,692.3l-11.74-36.77s-6.69-17.43,2.84-27.35,20.69-6.31,20.69-6.31,18.67-41,52.66-34.42c14.54,2.8,13.54,16,13.54,16s22.8-23.7,47-11.79c25.09,12.34,30.44,37.7,18.21,51.42-16.69,18.71-44.93,5.84-44.93,5.84s-.77,17.54-22.14,24.93c-24.7,8.55-46.82-11.68-46.82-11.68s-8.73,29.93-17.62,33C306,698,302.65,692.3,302.65,692.3Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest5",
    d: "M383.7,736.87A15.31,15.31,0,1,1,399,721.56,15.33,15.33,0,0,1,383.7,736.87Zm0-26.62A11.31,11.31,0,1,0,395,721.56,11.32,11.32,0,0,0,383.7,710.25Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest5",
    d: "M431.22,725.53a15.31,15.31,0,1,1,15.31-15.31A15.33,15.33,0,0,1,431.22,725.53Zm0-26.62a11.31,11.31,0,1,0,11.31,11.31A11.32,11.32,0,0,0,431.22,698.91Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest5",
    x: 396.36,
    y: 713.89,
    width: 22.34,
    height: 4,
    transform: "translate(-216.93 178.65) rotate(-19.64)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest5",
    x: 334.52,
    y: 670.62,
    width: 4,
    height: 74.59,
    transform: "translate(-447.26 717.13) rotate(-65.25)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest6",
    d: "M232.83,951.66l15.46,122-105,68.75s-59.41,35.33-111.85-4.28-23-94.19-23-94.19l110.25-211.4s11.08-31.37,38.08-40.18,60.05,13.22,60.05,13.22l66.78,34.12,4.65-17.25h71.19l2.07,25.15,70.88-9.38s34.15-3.92,49,9,14.68,27.41,14.68,27.41l22,213.88H205.43"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest7",
    d: "M389.64,1088.5,485.7,921.26a32,32,0,0,1,27.75-16.07H716.72a20,20,0,0,1,17.35,30L646,1088.5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest7",
    d: "M659.05,1065.77H304.11a46.35,46.35,0,0,0-39.88,22.73H646Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest8",
    d: "M582.41,1012.66a15.81,15.81,0,1,1,15.81-15.81A15.83,15.83,0,0,1,582.41,1012.66Zm0-26.62a10.81,10.81,0,1,0,10.81,10.81A10.82,10.82,0,0,0,582.41,986Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest2",
    d: "M232.83,951.66l15.46,122,126.49-85.33s21.88-14,18.8-31.41c0,0,16-7.3,9-21,0,0,15.43-6.17,12.06-16.27s-18.23-7.29-18.23-7.29l-63.54,15.28,14.45-17.81s8.95-12-1.56-17c-9.06-4.32-24.24,8.3-24.24,8.3L273,939.82Z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest3",
    x: 356.59,
    y: 944.72,
    width: 48.76,
    height: 5,
    transform: "translate(-396.84 285.87) rotate(-27.72)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest3",
    x: 367.87,
    y: 961.33,
    width: 27.56,
    height: 5,
    transform: "translate(-431.58 320.96) rotate(-30.07)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest3",
    d: "M389.53,942.3a14.75,14.75,0,0,1,1.23-10.68c3.29-6.69,10.82-12,22.37-16l1.6,4.73c-24,8.1-20.62,19.81-20.46,20.3Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest3",
    d: "M323,911.91a20.31,20.31,0,0,1-10.09-2.8l2.46-4.35a14.48,14.48,0,0,0,11.5,1.61c9.74-2.71,16.57-14.66,16.64-14.78l4.36,2.44c-.32.57-7.89,13.87-19.64,17.15A19.3,19.3,0,0,1,323,911.91Z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest3",
    x: 306.18,
    y: 928.05,
    width: 26.99,
    height: 5,
    transform: "translate(-195.34 92.17) rotate(-12.6)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest8",
    x: 122.66,
    y: 963.8,
    width: 112.12,
    height: 5,
    transform: "translate(-246.15 80.2) rotate(-15.14)"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest8",
    x: 165.11,
    y: 932.97,
    width: 60.47,
    height: 5,
    transform: "translate(-755.32 838.05) rotate(-72.35)"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest8",
    x: 421.14,
    y: 951.66,
    width: 5,
    height: 77.64
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest8",
    x: 223.42,
    y: 1078.58,
    width: 27.09,
    height: 5,
    transform: "translate(-553.36 306.3) rotate(-33.21)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest8",
    x: 359.74,
    y: 847.57,
    width: 5,
    height: 16.13,
    transform: "translate(-81.63 39.36) rotate(-5.59)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest5",
    x: 225.63,
    y: 1086,
    width: 450.36,
    height: 5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-contest4",
    cx: 427.33,
    cy: 708.25,
    r: 3.34
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-contest4",
    cx: 378.79,
    cy: 719.65,
    r: 3.34
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest9",
    d: "M93.2,1156.87h-5c0-24.24-7.23-43.22-21.49-56.41C41.06,1076.74.8,1079.6.39,1079.63l-.39-5c1.73-.14,42.79-3.08,70.08,22.13C85.42,1110.94,93.2,1131.16,93.2,1156.87Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-contest10",
    points: "955.13 735.95 926.46 717.04 849.92 816.24 756.68 749.85 713.45 749.85 713.45 806.78 743.26 850.48 999.48 850.48"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest11",
    d: "M886,736.72,837.85,561.31a30.77,30.77,0,0,0-29.68-22.64H596.11a20.52,20.52,0,0,0-19.79,26L624.43,740a30.79,30.79,0,0,0,29.69,22.64H866.18A20.52,20.52,0,0,0,886,736.72Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest11",
    d: "M632.35,828.49h173.5a44.82,44.82,0,0,1,38.57,22h-218Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-contest11",
    points: "707.18 850.48 763.66 640.99 682.9 640.99 626.43 850.48 707.18 850.48"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest8",
    x: 684.43,
    y: 699.33,
    width: 125.95,
    height: 5,
    transform: "translate(-123.62 1242.66) rotate(-75.04)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest8",
    x: 605.36,
    y: 697.89,
    width: 123.05,
    height: 5,
    transform: "translate(-182.88 1162.12) rotate(-74.92)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest9",
    d: "M1198.75,698.75c-11-20-32.3-24-32.3-24l-62-12.87-67.64,1.57L1008,665.78s-39.24,2.43-50.22,13.81S926.46,717,926.46,717L955.13,736,926.7,850.48h263.62c2.45-11.71,4.59-18.8,3.89-28.42-.73-10.07-5.19-19.55-6.39-29.58-1.6-13.47,2.74-26.85,7-39.71C1194.84,752.77,1209.79,718.73,1198.75,698.75Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-contest12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest5",
    x: 488.04,
    y: 655.8,
    width: 1240.44,
    height: 28.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest5",
    x: 488.04,
    y: 712.85,
    width: 1240.44,
    height: 28.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest5",
    x: 488.04,
    y: 769.91,
    width: 1240.44,
    height: 28.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest5",
    x: 488.04,
    y: 826.96,
    width: 1240.44,
    height: 28.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest5",
    x: 488.04,
    y: 884.01,
    width: 1240.44,
    height: 28.53
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest13",
    d: "M1114.15,532.26l5.73-8.62c2.73-4.11,27.13-40.25,41-42a7.44,7.44,0,0,1,6.09,1.76,6.45,6.45,0,0,1,2.19,5.73c-.23,2.12-.94,8.59-23.92,24.36-11,7.53-22,13.68-22.06,13.75ZM1162,486.53a3.49,3.49,0,0,0-.53,0c-2.69.34-9.25,3.42-22.9,20.17-2.91,3.57-5.62,7.13-7.9,10.23,15.3-9.44,32.79-22.12,33.48-28.42a1.52,1.52,0,0,0-.55-1.45A2.26,2.26,0,0,0,1162,486.53Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest13",
    d: "M1111.84,527.87l8.89-5c8.53-4.82,37-20.17,45.15-15.81a5.13,5.13,0,0,1,2.74,4.3,7.53,7.53,0,0,1-2.07,5.66c-8.11,9-40.81,10.4-44.51,10.52Zm50.08-16.7c-2.32,0-7.64,1-19.4,6.26-3.11,1.4-6.17,2.88-8.89,4.25,11.22-1.15,25.2-3.56,29.2-8a2.52,2.52,0,0,0,.8-1.95.59.59,0,0,0,0-.22S1163.24,511.17,1161.92,511.17Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest14",
    d: "M1092.88,587.12a142.18,142.18,0,0,1-24.11,24.06c-23.49,20.76-61.74,22.3-85.51,5.87s-25.57-45.92-23.58-61.26c.42-3.22,1.2-7.71,2.26-13.1,0,0-8.64-9.22-6.93-14.26s5.84-4.46,11.62-7.41v.07c4.28-18.42,10-40.4,16-59.76A42.66,42.66,0,0,1,994,442.91h0c17.92-17.13,51.09-19.14,85.53-8,44.82,14.53,44.36,66.69,44.36,66.69C1125.37,520.05,1117.36,556.06,1092.88,587.12Z"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest15",
    x: 1044.49,
    y: 517.31,
    width: 24.4,
    height: 5,
    transform: "translate(-72.05 855.58) rotate(-42.76)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest4",
    x: 996.12,
    y: 494.57,
    width: 5,
    height: 17.46,
    transform: "translate(133.43 1211.83) rotate(-66.06)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-contest4",
    cx: 990.63,
    cy: 518.11,
    r: 3.34
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest15",
    d: "M975.75,559a24.5,24.5,0,0,1-4.3-.4l.87-4.92c4.06.72,7.17.25,9.27-1.4a8.86,8.86,0,0,0,3-5.79l5,.26a13.83,13.83,0,0,1-4.83,9.41A14.06,14.06,0,0,1,975.75,559Z"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest11",
    x: 596.43,
    y: 847.98,
    width: 593.89,
    height: 5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest14",
    d: "M1083.14,592.22l21.34,69.63s-47.84,39.53-71.2,39.53,3.56-38,3.56-38V626.66"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest4",
    d: "M1163.3,548.42c-8.23-14.25-23.7-22.31-41.34-23.4a87.2,87.2,0,0,0,1.9-23.4s.46-52.16-44.36-66.69c-34.44-11.17-67.61-9.16-85.53,8h0c.76,47.18,39.24,60.39,39.24,60.39s38.78-26.91,50.84,2.5c4.27,10.41,4.83,18.83,3.19,25.63-5.24,21.75-33,26.79-33.76,26.92-12.91,18-16,39.84-6.14,57,14.72,25.48,52.6,31.16,84.62,12.67S1178,573.9,1163.3,548.42Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-contest13",
    points: "1085.56 540.5 1074.92 540.83 1116.8 525.19 1127.44 524.86 1085.56 540.5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest14",
    d: "M995.81,793.85,1041.44,747l104.08,80.73-58,73.5s-27.39,44-73.63,40.41c-46-3.57-73.51-45.33-73.51-45.33L841.15,766.47s-44.29-61-27.7-69.69c0,0-15.79-18.08-1.07-26.91l-6.27-13.06s-6.44-11.48.87-15.65,19.2,7.72,19.2,7.72l33,35.69-1-19.83s-.62-10.5,8.53-11.52c8.15-.91,13.17,18.2,13.17,18.2l14.82,44.66Z"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest15",
    x: 1005.49,
    y: 787.94,
    width: 5,
    height: 31.04,
    transform: "translate(-247.08 1097.39) rotate(-51.74)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest15",
    x: 822.54,
    y: 664.96,
    width: 5,
    height: 37.53,
    transform: "translate(-245.25 735.2) rotate(-42.4)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest15",
    x: 821.63,
    y: 692.73,
    width: 5,
    height: 32.2,
    transform: "translate(-262.78 725.02) rotate(-41.55)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest15",
    d: "M879.33,677.49a10.66,10.66,0,0,1-6.18-2c-7.9-5.46-10.71-20.8-10.83-21.45l4.92-.88c.7,3.87,3.62,14.68,8.75,18.22a5.72,5.72,0,0,0,4.49,1l.93,4.91A11.44,11.44,0,0,1,879.33,677.49Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest15",
    d: "M811.21,666.29l-3-4a6.64,6.64,0,0,0,2.76-4.67c.66-5.39-4.05-12.57-5.92-14.89l3.88-3.15c.33.41,8.05,10,7,18.63A11.56,11.56,0,0,1,811.21,666.29Z"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest15",
    x: 860.45,
    y: 683.04,
    width: 5,
    height: 10.97,
    transform: "translate(-236.39 789.53) rotate(-43.84)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest15",
    d: "M1037.61,629.19a9.4,9.4,0,0,1-1,0l.44-5a18.7,18.7,0,0,0,12.82-4.71l3.28,3.77A24.13,24.13,0,0,1,1037.61,629.19Z"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest8",
    x: 1127.68,
    y: 791.22,
    width: 82.74,
    height: 5,
    transform: "translate(-148.64 1303.95) rotate(-55.34)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest8",
    d: "M1043.27,748.72l-3.66-3.41,40.12-43c.55-.58,13.23-13.89,22.17-16.2l1.25,4.84c-6.27,1.63-16.4,11.22-19.78,14.78Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest8",
    d: "M957.54,736.65l-4.81-1.39,9.6-33.11a29.4,29.4,0,0,1,16.5-18.58l2,4.57a24.3,24.3,0,0,0-13.66,15.24l0,.11Z"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest15",
    x: 855.84,
    y: 812.22,
    width: 5,
    height: 21.64,
    transform: "translate(-321.37 972.85) rotate(-51.03)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest16",
    d: "M282.83,215.26l-37.39-12.21s-18.6-5.52-16.14-16.41c2.26-10,26-7.2,26-7.2l58.4,6.66"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest4",
    d: "M262.55,231.58l89.35-86.27s7.64-8.59,11.52-4.62c3.73,3.81-3.95,11.94-3.95,11.94l-82.62,93.5-18.78,7.26a2,2,0,0,1-2.62-2.58Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest16",
    d: "M313.05,182.82l-4.18-20.37s-4.23-17.69,7.23-22.22,19,18.71,19,18.71L371,260.28l-65.62,58.56L291.17,275.7s-27.64-12.36-25.66-25.19l11.34-4.38,39.42-44.69"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest17",
    d: "M330.62,162.26a12.51,12.51,0,0,1-6.71-1.92c-8.34-5.18-10.22-19.2-10.29-19.8l5-.63c.44,3.4,2.73,12.94,8,16.19,2.21,1.36,4.75,1.52,7.78.47L336,161.3A16.31,16.31,0,0,1,330.62,162.26Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest17",
    d: "M238.94,190.14a51.24,51.24,0,0,1-10.19-1.06l1.1-4.88c.2,0,19.9,4.15,23.09-5.54l4.75,1.57C255,188.36,246.16,190.14,238.94,190.14Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest17",
    d: "M326.81,238.38a17.58,17.58,0,0,1-11.69-8.81c-6.27-11.37-1.28-28.75-1.22-28.92l4.74,1.58-2.37-.79,2.39.73c-1.19,4-3.56,17.33,1,25.21a12.61,12.61,0,0,0,8.37,6.15Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest17",
    d: "M310.36,261.65a24.5,24.5,0,0,1-12.29-3.9l-15.53-10.1,2.73-4.19,15.51,10.09c.08.06,10.91,6.82,15.33.2,3.09-4.64-5.44-13.45-8.78-16.27l-13.85-9.81,2.89-4.08,14.09,10a48.84,48.84,0,0,1,7,7.39c5.78,7.71,4.73,12.71,2.84,15.56A11.3,11.3,0,0,1,310.36,261.65Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest17",
    d: "M297.43,279.44a19.52,19.52,0,0,1-7.27-1.45l2-4.57-1,2.28,1-2.29c.29.13,7.34,3.11,11.94-1.72,2.65-2.78-2.35-9.27-4-11.1l-10.47-8.35,3.12-3.91L303.59,257c4,4.17,9.33,12.67,4.15,18.12A13.82,13.82,0,0,1,297.43,279.44Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest4",
    d: "M456.88,103.92s-11.81,15-28.23,8.38c0,0-19.34,44.05,20.14,56.41"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest4",
    d: "M596.19,161s-11.63,7.75-24.59-1.43c0,0-5.71,43.94,35.64,42.43,37.31-1.37,55.5-40.08,50.44-76.38C652.57,89,628.2,24.45,563.68,4.05"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest16",
    d: "M816.21,213.07a50,50,0,0,1,3.21-7.17c7.6-13.06,19.15-29.68,19.15-29.68s23-40.73,34.46-38.28c12.83,2.73,5.26,18.42,5.26,18.42L903,131.7s11-13.2,19.63-7.58c6.21,4,.62,17,.62,17s6-3.88,10.91,0c6.69,5.33-1.3,17.63-1.3,17.63s7.63,5.61.21,19.16l-34.44,54.54-2.77,40.76"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest17",
    x: 887.29,
    y: 155,
    width: 43.45,
    height: 5,
    transform: "translate(194.74 741.39) rotate(-49.09)"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest17",
    x: 896.87,
    y: 172.08,
    width: 42.98,
    height: 5,
    transform: "translate(170.08 734.88) rotate(-47.59)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest17",
    d: "M874.79,218.75l-4.87-1.13c5.36-23.18-7.2-27.62-7.32-27.66l-2.7-.89L876,155.28l4.52,2.16-13.86,29C871.2,189.27,879.69,197.56,874.79,218.75Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest7",
    d: "M920,290.83c-1.29,17.27-3,23.4-7.38,33.87s-9.86,20.65-12.16,31.77c-2.24,10.81-1.4,22.09-3.79,32.87-2.49,11.23-8.29,21.22-15.1,30.6a299.72,299.72,0,0,0-18.27,28.81c-8.12,14.35-22.49,34.87-41.39,42.23-45.14,17.56-78.17-20.21-78.17-20.21l-43.65-55.63,7.73,44.61H452.24l6.51-38.14s-28.25,41.19-73.31,38.14c-53.89-3.65-80.09-74.86-80.09-74.86l-19.48-48.67L371,260.28l27.95,76.81,47-74.28s10.29-18.08,27.94-24.72a37.46,37.46,0,0,1,5.37-1.59,107.69,107.69,0,0,1,40.22-.49l20.91,3.57,75.29-6.48,61.3-25.27a69.19,69.19,0,0,1,20.41-4.62c7.82-.56,16.88.27,25.22,4.62,20.64,10.75,25.58,28.77,25.58,28.77l43.44,112.55,24.65-136.67Z"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest13",
    x: 280.6,
    y: 317.75,
    width: 112.4,
    height: 5,
    transform: "translate(-127.31 295.92) rotate(-40.56)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest5",
    d: "M166.78,459.75,214,414.21a6.84,6.84,0,0,1,4.76-1.92h0a6.87,6.87,0,0,1,4.79,11.78L187,459.75"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest18",
    d: "M379.49,461.13,349.26,337.55a30,30,0,0,0-29.14-22.87H186.79a20,20,0,0,0-19.42,24.75L196.8,459.75"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest8",
    d: "M284.6,461.55l-3.47-3.6,47.24-45.54a9.36,9.36,0,0,1,15.17,3.22,9.2,9.2,0,0,1-2.14,10.23l-36.57,35.67L301.34,458l36.57-35.68a4.36,4.36,0,0,0-3-7.49,4.36,4.36,0,0,0-3,1.22Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest8",
    d: "M196.66,453.82l-3.49-3.58,28.67-28a4.37,4.37,0,0,0-3.05-7.49,4.38,4.38,0,0,0-3,1.22L192.43,438.5,189,434.9l23.33-22.49a9.31,9.31,0,0,1,6.5-2.62,9.37,9.37,0,0,1,6.54,16.07Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest16",
    d: "M697.32,203.21c-3.85,5.82-44.13,53.89-125.68,56.17-66.33,1.85-97.82-21.28-97.82-21.28h0a37.46,37.46,0,0,1,5.37-1.59,107.69,107.69,0,0,1,40.22-.49l20.91,3.57h.1l2.47-30.07c-28.37,6-58.62,4-79.86-16.16s-18.46-49.92-14.08-65S467.77,70.25,484,36.64a64.79,64.79,0,0,1,24.43-26.46h0C530.44-3.41,560-5,580.37,15.29,610.48,45.2,598.5,93.08,598.5,93.08S634.38,78.58,636,111.9c2,40.59-39.85,49.14-39.85,49.14l19.42,72.06,61.3-25.27A69.19,69.19,0,0,1,697.32,203.21Z"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest17",
    x: 596.83,
    y: 113.95,
    width: 24.71,
    height: 5,
    transform: "translate(0.76 236.8) rotate(-22.01)"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest4",
    x: 530.77,
    y: 90.34,
    width: 5,
    height: 21.24,
    transform: "translate(230.51 551.42) rotate(-66.82)"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest4",
    x: 476.04,
    y: 79.29,
    width: 5,
    height: 15.95,
    transform: "translate(296.25 538.26) rotate(-78.33)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest17",
    d: "M488.08,141.2c-3.81-2-5-4.56-5.39-6.39-.81-4.19,2-7.79,2.54-8.38l8.14-10.3,3.92,3.11-8.24,10.41c-.51.6-1.78,2.56-1.45,4.23.22,1.07,1.15,2,2.77,2.88Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest17",
    d: "M507.1,152.63a15.32,15.32,0,0,1-11.1-4.91l3.8-3.25a10.25,10.25,0,0,0,10.41,2.7c4.63-1.32,6.41-6.66,6.43-6.72l4.77,1.48c-.1.33-2.55,8-9.83,10A16.17,16.17,0,0,1,507.1,152.63Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest17",
    d: "M543.46,211.93l-1.16-4.86c.1,0,9.91-2.57,17.09-14.73l4.31,2.54C555.37,209,543.94,211.82,543.46,211.93Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-contest4",
    cx: 473.82,
    cy: 109.03,
    r: 3.34
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-contest4",
    cx: 522.36,
    cy: 120.42,
    r: 3.34
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-contest9",
    points: "493.64 360.06 511.6 458.75 569.31 458.75 586.56 360.06 493.64 360.06"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest9",
    d: "M605.66,436.28h-42v-5H605.6c1.37-.07,21.35-1.45,21.35-20.47,0-21.06-19-21.4-19.82-21.41H571.87v-5h35.27a28.73,28.73,0,0,1,12.33,3.28c5.7,3.05,12.48,9.54,12.48,23.13,0,19.28-17.13,25.09-26.18,25.47Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-contest9",
    cx: 540.1,
    cy: 360.05,
    rx: 46.46,
    ry: 22.96
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest8",
    d: "M540.1,385.52c-27.45,0-49-11.19-49-25.47h5c0,11.1,20.12,20.47,44,20.47s44-9.37,44-20.47h5C589.06,374.33,567.55,385.52,540.1,385.52Z"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest13",
    x: 136.78,
    y: 457.25,
    width: 596.6,
    height: 5
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest8",
    x: 685.73,
    y: 297.24,
    width: 5,
    height: 119.09,
    transform: "matrix(0.98, -0.2, 0.2, 0.98, -57.36, 144.55)"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest8",
    x: 410.6,
    y: 360.01,
    width: 120.68,
    height: 5,
    transform: "translate(20.78 750.53) rotate(-78.35)"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest8",
    x: 774.94,
    y: 359.92,
    width: 27.21,
    height: 5,
    transform: "translate(260.78 1051.34) rotate(-77.23)"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest8",
    x: 375.9,
    y: 346.11,
    width: 28.77,
    height: 5,
    transform: "translate(-122.74 451.81) rotate(-53.15)"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest17",
    x: 531.63,
    y: 244.54,
    width: 15.09,
    height: 5,
    transform: "translate(213.18 742.48) rotate(-81.27)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest8",
    d: "M590.13,298.37a19.25,19.25,0,1,0-17.69,26.84,18.11,18.11,0,0,0,2-.1A24.54,24.54,0,0,1,587,327.49a11.2,11.2,0,0,0,4.88,1,11.36,11.36,0,0,0,11-10.82,11.24,11.24,0,0,0-4.6-9.52A24.3,24.3,0,0,1,590.13,298.37Z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-contest8",
    cx: 611.4,
    cy: 280.1,
    r: 8.45
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest4",
    d: "M598.5,93.08s-79.47,18.24-90-82.9h0C530.44-3.41,560-5,580.37,15.29,610.48,45.2,598.5,93.08,598.5,93.08Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest4",
    d: "M596.19,161s-13.27,3.89-24.59-1.43c0,0-5.71,43.94,35.64,42.43"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest4",
    d: "M508.47,10.18C501.81,31.74,484,36.64,484,36.64A64.79,64.79,0,0,1,508.47,10.18Z"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest13",
    x: 858.81,
    y: 221.5,
    width: 5,
    height: 128.74,
    transform: "translate(113.72 800.34) rotate(-52.9)"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest19",
    x: 956.87,
    y: 283.72,
    width: 87.01,
    height: 5,
    transform: "translate(280.41 1037.44) rotate(-62.18)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest5",
    d: "M995,360.48l-4.15-2.78c10.94-16.3,35.72-42.81,55.67-44.56a18.46,18.46,0,0,1,15.64,5.67,12.45,12.45,0,0,1,1.15,1.37,80.68,80.68,0,0,1,9.87-5.47,58.6,58.6,0,0,1,43-1.81l-1.65,4.71a53.64,53.64,0,0,0-39.35,1.66,74.13,74.13,0,0,0-9.78,5.45,16,16,0,0,1-2.85,13.76c-4.48,5.75-9.19,11.34-14,11.69a6.12,6.12,0,0,1-4.77-1.75,6.61,6.61,0,0,1-1.9-6.13c1-6,9-13.44,17.27-19.31-.19-.25-.39-.48-.6-.71a13.55,13.55,0,0,0-11.61-4.15c-7.67.67-17.39,6-28.11,15.42A147.72,147.72,0,0,0,995,360.48Zm65.9-32.61c-7.29,5.37-13.42,11.49-14.08,15.27a1.63,1.63,0,0,0,.44,1.67,1.1,1.1,0,0,0,.94.37c3-.22,8.18-6.86,10.38-9.7A11.21,11.21,0,0,0,1060.89,327.87Z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-contest4",
    cx: 1048.33,
    cy: 272.09,
    r: 3.14
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest9",
    x: 198.77,
    y: 638.16,
    width: 5,
    height: 59.37,
    transform: "translate(-214.65 107.91) rotate(-19.83)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-contest19",
    d: "M189.64,726.46a189.75,189.75,0,0,0-21.16-27.69c-9.3-9.73-16.67-13.78-20.76-11.39a7.64,7.64,0,0,0-2.34,2.15q2.63,4.29,4.88,8.78c1.34,2.68,2.74,5.83,2.45,9.29-.31,3.8-3.32,7.87-7.63,7.87H145c-3.73,0-6.39-3-7.38-5.91a19.39,19.39,0,0,1-.48-8c.28-3.28.68-7.88,2.42-11.89A117.12,117.12,0,0,0,89.05,646.6l2-4.58a122.23,122.23,0,0,1,51.49,43.12,12.19,12.19,0,0,1,2.65-2.08c16.4-9.57,45.42,35.56,48.67,40.74ZM143,695.38a55.54,55.54,0,0,0-.89,6.65,15.1,15.1,0,0,0,.24,5.92c.48,1.43,1.63,2.51,2.68,2.52h0c1.35,0,2.53-1.76,2.66-3.28.18-2.17-.86-4.47-1.95-6.64Q144.48,697.93,143,695.38Z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-contest4",
    cx: 156.75,
    cy: 649.34,
    r: 3.14
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest9",
    x: 168.03,
    y: 981.57,
    width: 70.52,
    height: 5,
    transform: "translate(-282.77 104.6) rotate(-17.26)"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest9",
    x: 174.61,
    y: 1018.09,
    width: 67.29,
    height: 5,
    transform: "translate(-306.25 114.91) rotate(-18.07)"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-contest9",
    x: 181.28,
    y: 1052.66,
    width: 65.37,
    height: 5,
    transform: "translate(-366.02 148.1) rotate(-21.13)"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgContestIllustration);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "contest-illustration.44778f9.svg";